export * from 'vue/dist/vue.runtime.esm-bundler.js';

import { createApp as createVueApp } from 'vue/dist/vue.runtime.esm-bundler.js';
import { attachErrorHandler } from "@sentry/vue";

export const VueSentry = {
    install(app) {
        attachErrorHandler(app, { logErrors: true });
    },
};

export function createApp(...args) {
    return createVueApp(...args).use(VueSentry);
}
